<script lang="ts">
  import { getProgressBarContext } from '../progressBarContext'
  import componentAttributesStore from '../../../../stores/componentAttributes.svelte'
  import { THEMES } from '../../../../const/themes'

  type Props = {
    currentTime: number
    duration: number
    isLive?: boolean
  }

  let { currentTime, duration, isLive = false }: Props = $props()

  const progressBarContext = getProgressBarContext()
</script>

{#if progressBarContext.hoverTime !== 0 && ((!progressBarContext.isLiveStream && progressBarContext.hoverTime > currentTime) || (progressBarContext.isLiveStream && !isLive && duration - progressBarContext.hoverTime > currentTime))}
  <div
    class="absolute top-0 left-0 h-full duration-100 ease-in-out opacity-30"
    style={`background-color: ${componentAttributesStore.state.progressBarColor || componentAttributesStore.state.primaryColor || THEMES.DEFAULT.PROGRESS_BAR_COLOR}`}
    style:width={`${
      ((progressBarContext.isLiveStream
        ? duration - progressBarContext.hoverTime
        : progressBarContext.hoverTime) /
        duration) *
      100
    }%`}
  ></div>
{/if}
